import { formataTelefone } from "../../funcoes/Funcoes";
import "./header.css";
import "bootstrap-icons/font/bootstrap-icons.css";

function Header({ contexto }) {
  const analyticsID = contexto.analyticsID ? contexto.analyticsID : "";
  const adsID = contexto.adsID ? contexto.adsID : "";
  if (analyticsID != "") {
    const scriptTag = document.getElementById("metatag");
    const scriptTagSrc = document.getElementById("metaTagSrc");
    if (scriptTag != undefined && scriptTagSrc != undefined) {
      scriptTagSrc.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsID}`;
      scriptTag.text = `function setupGoogleAnalytics(){window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${analyticsID}');} setupGoogleAnalytics()`;
      scriptTag.type = "text/javascript";
    } else {
      let header = document.head;
      let scriptSrcMetaTag = document.createElement("script");
      let scriptFunctionMetaTag = document.createElement("script");
      scriptFunctionMetaTag.id = "metatag";
      scriptSrcMetaTag.id = "metaTagSrc";
      scriptSrcMetaTag.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsID}`;
      scriptFunctionMetaTag.text = `function setupGoogleAnalytics(){window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${analyticsID}');} setupGoogleAnalytics()`;
      scriptFunctionMetaTag.type = "text/javascript";
      header.appendChild(scriptFunctionMetaTag);
      header.appendChild(scriptSrcMetaTag);
    }
  }
  if (adsID != "") {
    const ads = document.getElementById("adstag");
    const adsSrc = document.getElementById("adsSrc");
    if (ads != undefined && adsSrc != undefined) {
      adsSrc.src = `https://www.googletagmanager.com/gtag/js?id=${adsID}`;
      adsSrc.text = `function setupGoogleAnalytics(){window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${adsID}');} setupGoogleAnalytics()`;
      adsSrc.type = "text/javascript";
    } else {
      let header = document.head;
      let scriptSrcMetaTag = document.createElement("script");
      let scriptFunctionMetaTag = document.createElement("script");
      scriptFunctionMetaTag.id = "adstag";
      scriptSrcMetaTag.id = "adsSrc";
      scriptSrcMetaTag.src = `https://www.googletagmanager.com/gtag/js?id=${adsID}`;
      scriptFunctionMetaTag.text = `function setupGoogleAnalytics(){window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${adsID}');} setupGoogleAnalytics()`;
      scriptFunctionMetaTag.type = "text/javascript";
      header.appendChild(scriptFunctionMetaTag);
      header.appendChild(scriptSrcMetaTag);
    }
  }

  const facebook =
    contexto.facebook && contexto.facebook !== ""
      ? contexto.facebook
      : "https://www.facebook.com/connectsaoficial/";
  const instagram =
    contexto.instagram && contexto.instagram !== ""
      ? contexto.instagram
      : "https://www.instagram.com/connectsaoficial/";
  const linkedin =
    contexto.linkedin && contexto.linkedin !== ""
      ? contexto.linkedin
      : "https://www.linkedin.com/company/connectsaoficial";
  const name = contexto.name;
  const telefoneFormatado =
    contexto.phone !== "" && contexto.phone.length > 7
      ? formataTelefone("" + contexto.phone)
      : formataTelefone("6130383595");
  const telefone =
    contexto.phone !== "" && contexto.phone.length > 7
      ? contexto.phone
      : "6130383595";
  const tipoTelefone =
    contexto.isWhatsapp === "S"
      ? `https://api.whatsapp.com/send?phone=${telefone}`
      : `tel:${telefone}`;

  return (
    <div>
      <div className="sobmenu">
        <div className="container">
          <div className="menu">
            <div className="label">
              <h4>
                Agora os clientes da {name} podem adquirir seu certificado
                digital com desconto.
              </h4>
            </div>
            <div className="contato">
              <h4>
                Atendimento:{" "}
                <a
                  className="font-tel"
                  target="blank_"
                  href={`${tipoTelefone}`}
                >
                  {telefoneFormatado}
                </a>{" "}
                |
                <a
                  className="icon-header"
                  href={`${facebook}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-facebook"></i>
                </a>
                <a
                  className="icon-header"
                  href={`${instagram}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-instagram"></i>
                </a>
                <a
                  className="icon-header"
                  href={`${linkedin}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-linkedin"></i>
                </a>
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div className="header">
        <div className="container">
          <div className="row">
            <div className="col-md-6 menu">
              <div className="logo">
                <img
                  src="https://cdn-saturno.s3.amazonaws.com/saturno/connect/logo_connect_certificado.png"
                  alt="logo-connect"
                />
              </div>
            </div>
            <div className="col-md-6 menu item-menu">
              <ul>
                <li>
                  <a href="#ecnpj">e-CNPJ</a>
                </li>
                <li>
                  <a href="#ecpf">e-CPF</a>
                </li>
                <li>
                  <a href="#nfe">NF-e</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Header;
